










































































import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import InputPhone from "@/components/inputPhone/InputPhone.vue";
import StateSelectorController from "@/components/location/StateSelectorController.vue";
import CitySelectorController from "@/components/location/CitySelectorController.vue";
import { Owner, owner as ownerFactory } from "@/api/owner/types";
import * as service from "@/services/owner";
import AgroOnOff from "@/components/agroOnOff/AgroOnOff.vue";

@Component({
  name: "OwnerForm",
  components: {
    StateSelect: StateSelectorController,
    CitySelect: CitySelectorController,
    VuePhoneNumberInput: InputPhone,
    AgroOnOff,
  },
})
export default class OwnerForm extends Vue {
  @Prop({ type: Owner, default: null })
  private owner!: Owner | null;

  @PropSync("status", { type: String, default: "" })
  private syncedStatus!: string;


  private ownerKey: string | null = null;
  private ownerName: string | null = null;
  private document: string | null = null;
  private tel: string | null = "";
  private phone: string | null = "";
  private email: string | null = null;
  private city: string = "";
  private uf: string = "";
  private isLoading: boolean = false;
  private timeout: number | null = null;

  get isKeyDisabled() {
    return this.syncedStatus !== "no-owner";
  }

  get isFetchingKey() {
    return this.syncedStatus === "fetching:by-key";
  }

  get isFetchingOwner() {
    return this.syncedStatus === "fetching:by-id";
  }

  get isFormDisabled() {
    return this.syncedStatus !== "open-form";
  }

  get isSubmitingInformation() {
    return this.syncedStatus === "submiting:owner";
  }

  get isInformationSaved() {
    return this.syncedStatus === "fetch:owner";
  }

  get isEditButtonDisabled() {
    return this.syncedStatus !== "fetch:owner";
  }

  private clearForm() {
    this.ownerKey = null;
    this.ownerName = null;
    this.document = null;
    this.tel = "";
    this.phone = "";
    this.email = null;
    this.city = "";
    this.uf = "";
  }

  private fillForm(owner: Owner) {
    this.ownerKey = owner.ownerKey;
    this.ownerName = owner.name;
    this.document = owner.document;
    this.tel = owner.phone;
    this.phone = owner.cellPhone;
    this.email = owner.email;
    this.uf = owner.state || "";
    this.city = owner.city || "";
  }

  private async setAdmitted() {
    const owner = this.owner!;

    owner.admitted =  !owner.admitted;

    let ownerResponse: Owner = owner;

    if (owner.admitted) {
      ownerResponse = await service.unadmit(owner);
    } else {
      ownerResponse = await service.admit(owner);
    }

    owner.admitted = ownerResponse.admitted;
  }

  @Watch("syncedStatus", { immediate: true })
  private onStatusChanged(status: string, oldStatus: string) {
    if (status === "initial") {
      this.clearForm();
      this.syncedStatus = "no-owner";
    }

    if (status === "fetch:no-owner") {
      if (oldStatus === "fetching:by-key") {
        this.syncedStatus = "open-form";
      }

      if (oldStatus === "fetching:by-id") {
        this.syncedStatus = "open-cpf";
      }
    }

    if (status === "fetch:owner") {
      this.fillForm(this.owner!);
    }
  }

  private clearOwner() {
    this.$emit("reset");
    this.syncedStatus = "initial";
    ((this.$refs.ownerKeyInput as Vue).$el as HTMLInputElement).focus();
  }

  @Watch('onwnerKey')
  private editedKey() {
    if (this.timeout)
        clearTimeout(this.timeout); 

      this.timeout = setTimeout(() => {
        this.syncedStatus = "fetching:by-key";
        this.$emit("input:owner-key", this.ownerKey);
      }, 1750); // delay
  }

  private editForm() {
    this.syncedStatus = "open-form";
  }

  private saveOwner() {
    if (this.syncedStatus === "open-form") {
      let owner: Owner;
      if (this.owner === null) {
        owner = ownerFactory(
          null,
          this.ownerName!,
          this.ownerKey!,
          this.document,
          this.email,
          this.tel,
          this.phone,
          this.uf,
          this.city
        );
      } else {
        owner = ownerFactory(
          this.owner.uuid,
          this.ownerName!,
          this.ownerKey!,
          this.document,
          this.email,
          this.tel,
          this.phone,
          this.uf,
          this.city
        );
      }
      this.syncedStatus = "submiting:owner";
      this.$emit("submit:owner", owner);
    }
  }
}
